<template>
  <div class="process-bar" :style="{height: selectorHeight + 'px'}">
    <div class="container">
      <div class="process-window">
        <div class="process-percentage">
          <span class="percentage-value">{{percentage}}</span>
          <span class="percentage-symbol">%</span>
        </div>
        <div class="process-text">
          <span>{{text}}</span>
        </div>
        <div class="bar-container">
          <div class="bar-value" :style="{width: percentage + '%'}">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as Config from 'common/script/config'
export default {
  name: 'processBar',
  props: ['percentage', 'text'],
  created: function () {
    var size = Config.documentSize()
    this.selectorHeight = size.height - 50
  },
  data () {
    return {
      selectorHeight: 0
    }
  },
  methods: {
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.process-bar
  position absolute
  width 100%
  top 50px
  left 0px
  background-color rgba(0, 0, 0, 0.4)
  z-index 99
  .container
    position relative
    display block
    width 100%
    height 100%
    .process-window
      position absolute
      width 400px
      height 200px
      top 50%
      left 50%
      margin-left -200px
      margin-top -100px
      background-color #ffffff
      border-radius 4px
      line-height initial
      .process-percentage
        width 100%
        margin-top 48px
        text-align center
        color #000000
        .percentage-value
          font-size 30px
        .percentage-symbol
          font-size 12px
      .process-text
        width 100%
        padding 10px 0px
        text-align center
        font-size 14px
      .bar-container
        position relative
        width 300px
        height 2px
        margin 36px auto
        border-radius 1px
        background-color #f5f5f5
        .bar-value
          height 2px
          border-radius 1px
          background-color #3d3d3d
          transition width 0.2s
</style>



// WEBPACK FOOTER //
// src/components/Notebook/ProcessBar.vue